import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";
import checkIconRed from "../../../resources/images/alert-circle.svg";

const styles = createUseStyles(theme => ({
  loyaltyTermsModal: {
    height: "750px",
    width: "700px",
    minWidth: "700px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px",
      },
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
      marginBottom: "20px"
    },
    "& .modal-body": {
      padding: "0px 24px",
    },
    "& .modal-content": {
      height: "100%"
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "auto",
      minWidth: "auto",
    },
  },
  quillEditor: {
    padding: "12px",
    "& .ql-container": {
        border: "none"
    }
  },
  modalContent: {
    height: "750px",
    margin: "0 0 0 0"
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  checkbox: {
    marginRight: "12px"
  },
  btnContainer: {
    marginTop: "32px",
    marginBottom: "16px"
  },
  termsContentHeading: {
    fontWeight: "600",
    fontSize: "24px",
    lineHeight: "32px",
    color: colors.lightBlack,
    marginBottom: "16px"
  },
  descriptionContainer: {
    height: "456px",
    borderRadius: "16px",
    backgroundColor: colors.brightBlue,
    overflow: "auto",
  },
  descriptionContainerTall: {
    height: "585px",
    borderRadius: "16px",
    backgroundColor: colors.brightBlue,
    overflow: "auto",
  },
  termsCheckbox: {
    marginTop: "32px",
    flex: "none",
    cursor: "pointer",
    "&:hover": {
      border: "1px solid " + colors.primary600Blue,
      backgroundColor: colors.primary100Blue + "!important",
    },
  },
  labelClass: {
    fontSize: "16px",
    marginTop: "32px",
    marginLeft: "12px",
  },
  agreeBtn: {
    height: "100%",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "20px",
    fontFamily: theme.fontFamily,
  },
  colRemove: {
    padding: "0px",
    margin: "0px"
  },
}));

export default styles;